import shaka from "shaka-player";

export function responseProcessor(responseType, response) {
  switch (responseType) {
    case shaka.net.NetworkingEngine.RequestType.MANIFEST:
      modifyAudioLangsInManifest(response);
      break;
  }
}

function modifyAudioLangsInManifest(response) {
  let manifestText = new TextDecoder().decode(response.data);
  manifestText = manifestText.replace(
    /(lang|id)="([a-z]{2})-x-([0-9]+)"/g,
    '$1="$2-$3"'
  );

  // yes, shaka expects that you must MODIFY the response object
  // NOT to create a new object and NOT to return it
  response.data = new TextEncoder().encode(manifestText).buffer;
}
